function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3345"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3066",
  d: "M234.103 53.137c.108-3.085-.06-7.046-.533-7.6-1.137-1.333-2.838-3.384-4.232-3.842-1.758-.578-12.749-1.354-14.493.3s-2.78 5.885-2.986 8.479c-.233 2.94-.732 4.824.075 4.962 2.961.5 13.9-.227 16.776-.369 2.581-.123 5.357-.915 5.393-1.93z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3067",
  d: "M211.835 50.533s-10.829-.147-10.932.4c-.374 2.026 2.66 10.715 4.1 10.746 3.91.088 23.794-1.87 28.079-2.633 1.1-.2.525-4.851.465-4.941",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3068",
  d: "M207.563 50.401l-3.34-13.4s-5.578 9.75-5.435 12.581 3.5 14.693 4.034 14.823c1.185.29 25.35-4.695 25.35-4.695",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3069",
  d: "M204.149 37.184c1.191-2.345 9.805-19.346 13.483-21.873 4.914-3.377 49.913-4.864 52.483-2.6 4.484 3.946 11.475 27 10.482 31.161-.569 2.387-2.08 3.935-3.511 4.09-3.632.394-42.938 5.277-42.938 5.277",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3070",
  d: "M240.827 12.417c3.744 7.58 9.858 30.646 11.012 38.5",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3071",
  d: "M289.337 60.566c.08.014.206 1.91-.177 2.01a67.91 67.91 0 01-8.131.795 3.688 3.688 0 01-.009-2.181 42.766 42.766 0 018.317-.624z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3326"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3072",
  d: "M253.87 65.64c.1.016.256 2.156-.22 2.269a92.661 92.661 0 01-10.1.9 3.8 3.8 0 01-.011-2.463c.187-.19 8.473-1.011 10.331-.706z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3073",
  d: "M287.903 60.38c-.157-1.4-.306-1.839-.562-1.846-.839-.019-6.035.365-6.28.755a5.349 5.349 0 00-.089 1.93",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3327"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3074",
  d: "M252.09 65.431c-.2-1.58-.38-2.077-.7-2.084-1.042-.021-7.5.411-7.8.852a5.518 5.518 0 00-.111 2.18",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3075",
  d: "M288.184 62.786c-.1 1.052-.437 1.582-.727 1.705a16.944 16.944 0 01-6.057.971c-.26-.061-.179-1.093-.277-1.924",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3328"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3076",
  d: "M252.432 68.147c-.125 1.188-.542 1.787-.9 1.926a22.976 22.976 0 01-7.526 1.1c-.323-.069-.223-1.234-.344-2.172",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3077",
  d: "M135.815 77.103c-3.117.346-38 .365-38 .365s5.467 2.984 3.7 30.532c-.075 1.185 23.537 1.769 26.228-.583s.725-11.687 1.909-14.282c1.951-4.276 7.884-8.413 7.837-9.965-.159-5.335.461-6.306-1.674-6.067z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3078",
  d: "M208.715 12.25c.389-.523-26.467-2.937-29.105-1.981s-1.527 1.146-4.7.872-35.652-1.038-39.013-1.208c-.869-.044-1.78-1.288-2.231-1.288-2.06 0-12.383-.008-13.945.922-7.712 4.59-41.608 33.438-41.608 33.438s109.413 6.827 109.654 6.546c2.197-2.579 20.088-36.148 20.948-37.301z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3079",
  d: "M182.441 50.34c-3.545.215-31.419-1.986-35.62-1.242s-4.723 1.286-8.445.984-54.756-3.6-54.756-3.6l-1.515-1.539-10.48-.946 6.481-1.056",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3080",
  d: "M141.737 117.945c.98-.034-5.255 26.876-7.716 27.383-10.4 2.141-124.037-.556-132.765-21.878-.508-1.237-.055-17.717-.055-17.717a46.014 46.014 0 014.132-2.683c5.219 15.695 116.293 15.577 136.404 14.895z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3081",
  d: "M144.741 116.502c2.8-14.133 50.365-57.762 51.9 16.011 0 .14 91.3-23.257 91.3-23.257s5.9-50.19 3.41-54.682c-4.044-7.3-13.586-43.749-19.011-47.016-2.84-1.71-16.039-3.877-24.025-4.336S143.776-3.461 121.279 7.199c-10.124 4.8-39.631 30.773-45.435 35.912",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3329"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3082",
  d: "M144.665 116.529l-3.445 1.392",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3083",
  d: "M190.037 45.476c-8.03-.965-58.621-2.131-60.639-4.463s-1.822-4.226-5.29-4.776-10.188-1.623-13.532-.17-10.329 5.237-13.425 5.036-16.991.356-16.991.356",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3084",
  d: "M89.277 117.494c.178-9.045 1.054-28.943.211-31.281-.733-2.031-5.8-12.025-7.256-12.689-5.445-2.482-66.434-7.188-67.342-6.129-1.663 1.936-4.5 9.328-4.566 9.81-1.088 8.119-.9 29.732-.9 29.732",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3085",
  d: "M126.891 146.192c-1.765 5.374-2.832 9.461-2.832 9.461l-4.887 4.19s-88.307.689-108.48-16.666c-.515-.442-1.658-7.149-2.126-12.943",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3086",
  d: "M284.885 36.637l57.646 3.1s9.222 9.731 3.115 39.107l.526 2.967-2.1 8.716s-8.073 4.224-7.971 3.5c5.123-36.2-22.145-35.178-27.759 11.134-.16 1.324-20.41 3.576-20.41 3.576",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3087",
  d: "M336.224 39.476c-7.692.909-48.893 4.521-48.893 4.521",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3088",
  d: "M323.004 40.69l-37.4-1.7",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3089",
  d: "M343.628 41.513l-55.348 5.474",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3090",
  d: "M346.679 50.4c-1.683.014-2.864-.02-2.872.324-.02.718.085 5.622.256 6.237a26.554 26.554 0 011.3 2.555c.307 2.506-.46 11.392-.221 11.47l1.775.086",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3091",
  d: "M166.588 10.98c-3.852 2.334-3.566 5.35-9.007 5.292-3.947-.042-18.946-.521-19.637-1.576-.438-.669 2.425-4.646 2.425-4.646",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3092",
  d: "M86.496 33.852c-5.763-.376-6.666-.808-7.9.07-.665.474-2.586 2.314-2.71 3.147-.294 1.994-.725 6.32-.725 6.32",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3093",
  d: "M137.774 13.753c-4.453.319-7.642.078-9.179.908-3.274 1.768-12.561 8.082-12.561 8.082s.217 5.144-.385 5.8a35.632 35.632 0 01-7.7 5.589c-.449.215-6.068-.92-6.747-.476-.581.382-5.467 4.035-4.855 6.858",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3094",
  d: "M114.089 27.522c-.028.379-6.36 4.887-6.795 4.771-.7-.184-2.652-1.478-2.314-2.011.37-.584 6.893-4.74 7.777-5.087.526-.206 1.372 1.781 1.332 2.327z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3095",
  d: "M136.544 42.181c-.855-3.465-8.885-10.336-15.427-6.437",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3330"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3096",
  d: "M138.853 42.438c-1.544-6.047-11.445-14.348-19.694-7.029",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3097",
  d: "M71.493 43.846c-9.51 1.274-53.56 12.327-56.912 15.41s-5.07 6.6-5.285 9.422c-.5 6.554-1.918 24.107-1.918 24.107a11.7 11.7 0 00-1.98 10.751",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3098",
  d: "M118.024 126.989a42.3 42.3 0 01.386 8.016c-.031.568-4.669 3.964-5.7 4.28-1.239.383-15.766.143-16.841-1.312-.842-1.141-1-10.275-.444-11.045.689-.957 22.443-.589 22.599.061z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3099",
  d: "M252.994 52.805c2.1 4.938 2.429 4.533 2.51 10.849s-2.691 52.648-2.691 52.648",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3100",
  d: "M346.03 78.229c1.963.554 2.616.277 2.164 3.422s-1.56 6.793-3.774 8.68",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3101",
  d: "M193.456 51.177c-6.6.859-78.582 5.916-105.172 18.124",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3102",
  d: "M76.725 82.73c-4.353-.014-46.239-3.973-58.444-6.418",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3331"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3103",
  d: "M79.664 88.803c-10.689.272-57.194-3.917-62.369-5.422",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3332"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3104",
  d: "M79.804 96.406c-12.6 1.52-55.488-3.348-63-5.785",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3333"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3105",
  d: "M76.791 103.454c-14 .686-51.133-3.935-58.644-6.372",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3334"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 105",
  cx: 22.751,
  cy: 39.432,
  rx: 22.751,
  ry: 39.432,
  transform: "rotate(-170.91 100.402 85.337)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3335"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 106",
  cx: 13.82,
  cy: 23.145,
  rx: 13.82,
  ry: 23.145,
  transform: "rotate(-170.91 96.487 76.95)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3336"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 107",
  cx: 11.686,
  cy: 27.287,
  rx: 11.686,
  ry: 27.287,
  transform: "rotate(-176.21 169.253 62.564)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3337"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 108",
  cx: 7.027,
  cy: 16.086,
  rx: 7.027,
  ry: 16.086,
  transform: "rotate(-176.21 166.998 57.297)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3106",
  d: "M324.825 134.895c-4.378 2.673-30.4 9.424-28.781-26.933",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3107",
  d: "M167.917 181.887c-14.344 1.938-40.7 3.769-41.63-33.7",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3108",
  d: "M179.818 105.107c-8.282-3.411-18.919-5.139-24.133-4.156",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3109",
  d: "M327.139 81.113c-2.867-1.261-8.187-2.36-11.625-1.619",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3110",
  d: "M322.625 93.968c5.165 6.187 7.158 21.877-2.545 29.292",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3111",
  d: "M169.853 120.513c12.3 10.172 11.855 42.665-8.693 42.878",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgDriverSideFrontQuarterGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310.268,
    height: 186.609,
    viewBox: "0 0 350 187"
  }, props), _ref);
}

export default SvgDriverSideFrontQuarterGraphic;